import $ from 'jquery';

import application from 'application/application';

import '@advise/genese-initials';

import path, { dirname } from 'path';

const controller = 'DefaultController';

application.controller(controller, [
	'$scope',
	'$http',
	'$state',
	'helper',
	'API',
	'authentication',
	'$rootScope',
	'permissions',
	'transformDate',
	(
		$scope,
		$http,
		$state,
		helper,
		API,
		authentication,
		$rootScope,
		permissions,
		transformDate
	) => {
		/** @TODO: Descrever.*/
		$scope.$state = $state;

		$scope.templateDir = path.resolve(
			dirname,
			'/partials/breadcrumbs.template.html'
		);

		/** Assina para os templates uma instância de `Date` no momento da renderização deste controller. */
		$scope.renderDate = new Date();

		$scope.hasGroup = false;

		$rootScope.toggleMenuActive = true;

		$scope.userGroups = helper.responseStore();

		$scope.currentGroupPage = 1;
		$scope.totalGroupPages = 1;
		$scope.totalGroupRegisters = 0;

		$scope.userName = authentication.getUserData('nome');

		$scope.groupSelected = localStorage.getItem('__groupSelected__');

		$scope.groupUserData = JSON.parse(
			localStorage.getItem('__groupUserData__')
		);

		$scope.idUserClient = authentication.getUserData('idUsuarioCliente');

		$scope.idCliente = authentication.getUserData('idCliente');

		$scope.userEmail = authentication.getUserData('email');

		let logoPartner = localStorage.getItem('__authenticationLogo__');

		if (logoPartner != 'null') {
			$rootScope.logoPartner = {
				avatar: `data:image/png;charset=utf-8;base64, ${logoPartner}`
			};
		} else {
			let nameArr = authentication.getUserData('nome').split(' ');

			$rootScope.logoPartner = {
				default: {
					light: $(document.createElement('img'))
						.initial({
							name:
								nameArr.length == 1
									? nameArr[0]
									: `${nameArr[0]} ${nameArr[nameArr.length - 1]}`,
							height: 40,
							width: 60,
							fontSize: 16,
							seed: 5,
							textColor: '#000000',
							backgroundColor: 'rgba(0, 0, 0, .12)',
							radius: 40
						})
						.attr('src'),
					dark: $(document.createElement('img'))
						.initial({
							name:
								nameArr.length == 1
									? nameArr[0]
									: `${nameArr[0]} ${nameArr[nameArr.length - 1]}`,
							height: 40,
							width: 60,
							fontSize: 16,
							seed: 5,
							textColor: '#ffffff',
							backgroundColor: 'rgba(255, 255, 255, .16)',
							radius: 40
						})
						.attr('src')
				}
			};
		}

		$scope.checkGroupClient = () => {
			$http({
				...helper.http(API.customers, 'GET'),
				params: {
					...helper.httpFields(['possuiGrupo']),
					IDs: $scope.idCliente
				}
			}).then(async response => {
				$rootScope.haveGroup = response.data.itens[0].possuiGrupo;

				await $scope.checkGroup($scope.userGroups);
			});
		};

		$scope.checkGroup = responseStore => {
			if (!$rootScope.haveGroup) return;

			responseStore.setReady(false);

			let params = {
				paginaAtual: $scope.currentGroupPage,
				registrosPorPagina: 5,
				IdsSituacaoGrupoUsuario: [-1],
				campos: '*',
				IdsClientes: [$scope.idCliente],
				ordenacao: 'nomeGrupo'
			};

			if ($scope.searchUserGroupQuery)
				params.nomeGrupo = $scope.searchUserGroupQuery;

			$http({
				...helper.http(API.groupUsers, 'GET'),
				params: params
			})
				.then(response => {
					if (!response.data.itens.length > 0) {
						if ($scope.searchUserGroupQuery) {
							responseStore.setItems(response.data.itens);
							responseStore.setReady(true);

							return;
						}

						$scope.hasGroup = false;

						return;
					}

					$scope.totalGroupPages = response.data.paginacao.paginaTotal;

					let groups = response.data.itens.filter(group => {
						let users = [];

						if (group.listaUsuariosGrupo.length > 0) {
							users = group.listaUsuariosGrupo.filter(user => {
								return (
									user.idUsuarioCliente === parseInt($scope.idUserClient) &&
									user.ativo
								);
							});
						}

						return users.length > 0;
					});

					if ($scope.searchUserGroupQuery) {
						responseStore.setItems(groups);
						responseStore.setReady(true);

						return;
					}

					if (groups.length > 0) {
						$scope.hasGroup = true;
						responseStore.setItems(groups);
						localStorage.setItem('__hasGroup__', $scope.hasGroup);
					} else {
						localStorage.setItem('__hasGroup__', $scope.hasGroup);
						// $scope.selectGroupUser(false);
					}
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.openModalUserGroup = () => {
			if (!$scope.hasGroup) return;

			$scope.currentGroupPage = 1;
			$scope.totalGroupPages = 1;
			$scope.totalGroupRegisters = 0;

			$scope.recordGroupsUser().then(() => {
				$('#modalUserGroup').modal('show');
			});
		};

		$scope.nextGroupPage = () => {
			if ($scope.currentGroupPage < $scope.totalGroupPages) {
				$scope.currentGroupPage++;

				$scope.recordGroupsUser();
			}
		};

		$scope.firstGroupPage = () => {
			$scope.currentGroupPage = 1;

			$scope.recordGroupsUser();
		};

		$scope.prevGroupPage = () => {
			if ($scope.currentGroupPage > 1) $scope.currentGroupPage--;

			$scope.recordGroupsUser();
		};

		$scope.lastGroupPage = () => {
			$scope.currentGroupPage = $scope.totalGroupPages;

			$scope.recordGroupsUser();
		};

		$scope.searchUserGroup = async () => {
			$scope.currentGroupPage = 1;
			$scope.totalGroupPages = 1;
			$scope.totalGroupRegisters = 0;

			await $scope.recordGroupsUser();
		};

		$scope.selectGroupUser = (idGroup, groupUser = null) => {
			if (!idGroup) {
				localStorage.removeItem('__groupUserData__');
				localStorage.setItem('__groupSelected__', false);
				location.replace(location.origin + location.pathname);

				return;
			}

			let groupStorage = {
				idGrupo: groupUser.idGrupo,
				nomeGrupo: groupUser.nomeGrupo
			};

			localStorage.setItem('__groupUserData__', JSON.stringify(groupStorage));
			localStorage.setItem('__groupSelected__', true);

			location.replace(location.origin + location.pathname);
		};

		$scope.recordGroupsUser = async () => {
			await $scope.checkGroup($scope.userGroups);
		};

		$scope.checkGroupClient();

		/** @TODO: Descrever.*/
		$scope.signIn = auth => {
			auth['access_type'] = '94be650011cf412ca906fc335f615cdc';

			auth['grant_type'] = 'password';

			$http({
				...helper.http(API.login, 'POST'),
				data: auth
			}).then(response => {
				transformDate.formatDate(response.data.expires_in);

				authentication.signIn(response.data, () => {
					$('#modalQuickLogin').modal('hide');

					Object.keys($scope.permissions)
						.map(key => $scope.permissions[key])
						.forEach(permission => permission.update());
				});
			});
		};

		$scope.permissions = {
			publications: permissions.get('publications'),
			processes: permissions.get('processes'),
			subpoena: permissions.get('subpoena')
		};

		$scope.toggleMenu = () => {
			// $('.menu-bar').toggleClass('active');
			$rootScope.toggleMenuActive = !$rootScope.toggleMenuActive;
		};
	}
]);

export default controller;
